
export default class AdProvider_GoogleH5 {
    constructor(ad_client, ad_channel, onAdLoaded, onAdOpened, onAdClosed, onAdError) {
        this.ad_client = ad_client;
        this.ad_channel = ad_channel;
        this.rewardedAdAutoShow = false;
        this.onAdLoaded = onAdLoaded;
        this.onAdOpened = onAdOpened;
        this.onAdClosed = onAdClosed;
        this.onAdError = onAdError;
    }

    async setup() {

        if (this.isSetupLoading) {
            throw Error('GoogleH5 setup is in progress already');
        }
        this.isSetupLoading = true; //prevent async loading

        //as long as adBreak is set, then we can queue up the ad for when google ads script to finishes
  
        // //todo: wait until the plugin is ready or timeout
        // if (typeof adBreak === "undefined" || !adBreak) {
        //     console.log('GoogleH5 adBreak plugin not ready');
        //     reject('GoogleH5 adBreak plugin not ready');
        // }

        //one once per page load 
        //?does it need to be updatable, called more than once?
        if (this.isSetup) {
            console.log('GoogleH5.isSetup is already done');
            return;
        }
        try{
            await this.loadScript();
            console.log("adsbygoogle loaded")
        }catch(error){
            console.log(error);
            return;
        }
        

        if (typeof adConfig === "undefined") {
            console.log('GoogleH5 adBreak plugin not ready');
            throw Error('GoogleH5 adBreak plugin not ready');
        }

        adConfig({
            preloadAdBreaks: 'on',
            sound: 'on', //todo: check if muted or not
            onReady: () => {
                // this.isSetup = true;
                // this.isSetupLoading = false;
                console.log('GoogleH5.isSetup is ready');
            }
        });
        this.isSetup = true;
        this.isSetupLoading = false;
    }
    loadScript() {

        return new Promise(function (resolve, reject) {
            window.adsbygoogle = window.adsbygoogle || [];
            window.adBreak = window.adConfig = function (o) { adsbygoogle.push(o); }
           
            let script = document.createElement('script');
            script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
            script.setAttribute("async", "");
            script.setAttribute("data-ad-client", "ca-pub-2191584882036728"); 
            script.setAttribute("data-ad-channel", "4286624596");
            script.setAttribute("data-ad-frequency-hint", "60s");
            script.setAttribute("data-page-url", "cardsjd.com"); 
            script.setAttribute("crossorigin", "anonymous"); 
            //script.setAttribute("data-adbreak-test", "on"); //test mode
            script.onload = () => { 
                resolve("adsbygoogle loaded"); 
            };
            script.onerror = (e) => { 
                reject("Error loading JS adsbygoogle"); 
            };
            document.head.appendChild(script);
            // <!-- Google H5 game ads for web -->
            // <!-- data-adbreak-test="on" -->
            // <script async data-ad-client="ca-pub-2191584882036728" data-ad-channel="4286624596" data-ad-frequency-hint="60s"
            //     data-page-url="cardsjd.com" crossorigin="anonymous"
            //    src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js">
            // </script>
            // <script>
            //    window.adsbygoogle = window.adsbygoogle || [];
            //    var adBreak = adConfig = function (o) { 
            //    adsbygoogle.push(o);
            //    }
            // </script>
        });
    }
    loadAd() {
        console.log("GoogleH5.loadAd");
    };
    showAd() {

        console.log("GoogleH5.showAd");

        if (typeof adBreak === "undefined" || !adBreak) { console.log('GoogleH5 adBreak plugin not ready'); return; }

        if (!this.isSetup) {
            console.log("GoogleH5.showAd - isSetup is false");
            return; //todo: wait until setup is done and ad loaded then show ad
        }

        adBreak({
            type: 'next', // The type of this placement (required)
            name: 'post_game', // A descriptive name for this placement
            // (optional but highly recommended)
            beforeAd: () => { }, // Prepare for the ad. Mute and pause the game flow (optional)
            afterAd: () => {
                if (this.onAdClosed) this.onAdClosed({ adType: "interstitial" });
            }, // Resume the game and un-mute the sound (optional)
            adBreakDone: (placementInfo) => { console.log("placementInfo", placementInfo) }, // Always called (if provided) even if an ad didn’t show
        });
    };
    isAdLoaded() {
        return true;
    };
    isRewardedAdLoaded() {
        return true;
    };
    showRewardedAd() {
        console.log("GoogleH5.ShowRewardedAd");

        if (typeof adBreak === "undefined" || !adBreak) { console.log('GoogleH5 adBreak plugin not ready'); return; }

        //as long as adBreak is set, then we can queue up the ad for when google ads script to finishes
        // if (!this.isSetup) {
        //     console.log("GoogleH5.showAd - isSetup is false");
        //     return; //todo: wait until setup is done and ad loaded then show ad
        // }

        adBreak({
            type: 'reward', // The type of this placement
            name: 'reward_ad', // A descriptive name for this placement
            beforeAd: () => { }, // Prepare for the ad. Mute and pause the game flow
            afterAd: () => { }, // Resume the game and re-enable sound
            beforeReward: (showAdFn) => {
                showAdFn();
            }, // Show reward prompt (call showAdFn() if clicked)
            adDismissed: () => { }, // Player dismissed the ad before it finished.
            adViewed: () => {
                if (this.onAdClosed) this.onAdClosed({ adType: "rewarded", rewardAmount: 150 });
            }, // Player watched the ad–give them the reward.
            adBreakDone: (placementInfo) => { console.log("placementInfo", placementInfo) }, // Always called (if provided) even if an ad didn’t show
        });

    };
    loadRewardedAd() {
        console.log("GoogleH5.loadRewardedAd");

    };
    async showAppOpenAd(successCallback, failureCallback) {
        console.log("GoogleH5.ShowAppOpenAd");

        if (typeof adBreak === "undefined" || !adBreak) { console.log('GoogleH5 adBreak plugin not ready'); return; }

        //as long as adBreak is set, then we can queue up the ad for when google ads script to finishes
        // if (!this.isSetup) {
        //     console.log("GoogleH5.showAd - isSetup is false");
        //     return; //todo: wait until setup is done and ad loaded then show ad
        // }

        //setup then show if needed
        await new Promise((resolve) => {
            //https://developers.google.com/ad-placement/apis/adbreak
            adBreak({
                type: 'preroll', // The type of this placement
                adBreakDone: (e) => {
                    //e.breakFormat: "preroll"
                    //e.breakName: undefined
                    //e.breakStatus: "timeout" | "viewed"
                    //e.breakType: "preroll"
                    let status = e.breakStatus;
                    if (successCallback) successCallback(e);
                    resolve(status);
                }, // Always called (if provided) even if an ad didn’t show
                // Game should start after adBreakDone is called
            });
        });
    };

}


